/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as SplatRouteImport } from './routes/$'
import { Route as BearingFrequencyCalculatorRouteImport } from './routes/bearing-frequency-calculator'
import { Route as BecomeSchaefflerCustomerRouteImport } from './routes/become-schaeffler-customer'
import { Route as CampaignRouteImport } from './routes/campaign'
import { Route as ContactUsRouteImport } from './routes/contact-us'
import { Route as CopySharedWishlistRouteImport } from './routes/copySharedWishlist'
import { Route as CopyWishlistRouteImport } from './routes/copyWishlist'
import { Route as DigitalServiceRouteImport } from './routes/digitalService'
import { Route as FreecapacitycockpitRouteImport } from './routes/freecapacitycockpit'
import { Route as HousingselectionassistantRouteImport } from './routes/housingselectionassistant'
import { Route as LubricationSelectionAssistantRouteImport } from './routes/lubrication-selection-assistant'
import { Route as MediaLibraryRouteImport } from './routes/media-library'
import { Route as OpenOrdersRouteImport } from './routes/open-orders'
import { Route as PreviewContentRouteImport } from './routes/preview-content'
import { Route as SavedConfigsRouteImport } from './routes/saved-configs'
import { Route as ScandmcRouteImport } from './routes/scandmc'
import { Route as SdsMediaLibraryRouteImport } from './routes/sds-media-library'
import { Route as SelectaccountRouteImport } from './routes/selectaccount'
import { Route as SelectionassistantRouteImport } from './routes/selectionassistant'
import { Route as StcRouteImport } from './routes/stc'
import { Route as WishlistRouteImport } from './routes/wishlist'
import { Route as CCategoryCodeRouteImport } from './routes/c/$categoryCode'
import { Route as CartIndexRouteImport } from './routes/cart/index'
import { Route as CartRequestRouteImport } from './routes/cart/request'
import { Route as CartStoreFinderRouteImport } from './routes/cart/store-finder'
import { Route as DatasheetProductDesignationRouteImport } from './routes/datasheet/$productDesignation'
import { Route as EmbeddedProductConfiguratorProductCodeRouteImport } from './routes/embeddedProductConfigurator/$productCode'
import { Route as LmsActivateRouteImport } from './routes/lms/activate'
import { Route as MyAccountIndexRouteImport } from './routes/my-account/index'
import { Route as MyAccountAccountSettingsRouteImport } from './routes/my-account/accountSettings'
import { Route as MyAccountContractOverviewRouteImport } from './routes/my-account/contractOverview'
import { Route as MyAccountNewContractRouteImport } from './routes/my-account/new-contract'
import { Route as MyAccountOrderAndQuoteSettingsRouteImport } from './routes/my-account/orderAndQuoteSettings'
import { Route as NotificationsIndexRouteImport } from './routes/notifications/index'
import { Route as NotificationsSettingsRouteImport } from './routes/notifications/settings'
import { Route as OrdersIndexRouteImport } from './routes/orders/index'
import { Route as OrdersIdRouteImport } from './routes/orders/$id'
import { Route as PProductCodeRouteImport } from './routes/p/$productCode'
import { Route as PlpCategoryCodeRouteImport } from './routes/plp/$categoryCode'
import { Route as QuoteIndexRouteImport } from './routes/quote/index'
import { Route as QuotesIndexRouteImport } from './routes/quotes/index'
import { Route as QuotesIdRouteImport } from './routes/quotes/$id'
import { Route as RequestLinearConfigurationQuoteConfirmationRouteImport } from './routes/requestLinearConfigurationQuote/confirmation'
import { Route as SavedConfiguratorCodeRouteImport } from './routes/savedConfigurator/$code'
import { Route as SearchIndexRouteImport } from './routes/search/index'
import { Route as SearchSearchpageRouteImport } from './routes/search/searchpage'
import { Route as SendLinearConfigurationsViaEmailConfirmationRouteImport } from './routes/sendLinearConfigurationsViaEmail/confirmation'
import { Route as SendWishlistViaEmailConfirmationRouteImport } from './routes/sendWishlistViaEmail/confirmation'
import { Route as StaticWelcomeRouteImport } from './routes/static/welcome'
import { Route as StoreFinderIndexRouteImport } from './routes/store-finder/index'
import { Route as StoreFinderConfirmationRouteImport } from './routes/store-finder/confirmation'
import { Route as ProductCodeConfiguratorPageLinearConfiguratorRouteImport } from './routes/$productCode/configuratorPage/LinearConfigurator'
import { Route as CheckoutOrderConfirmationReferenceCodeRouteImport } from './routes/checkout/orderConfirmation/$referenceCode'
import { Route as LoginPwChangeRouteImport } from './routes/login/pw/change'
import { Route as QuoteConfirmIndexRouteImport } from './routes/quote/confirm/index'
import { Route as QuoteConfirmOrderCodeRouteImport } from './routes/quote/confirm/$orderCode'
import { Route as RegisteredUserIndexRouteImport } from './routes/registered/user/index'
import { Route as RegisteredUserConfirmationRouteImport } from './routes/registered/user/confirmation'
import { Route as CarriagesProductCodeCarriagesConfiguratorPageLinearConfiguratorRouteImport } from './routes/carriages/$productCode/carriagesConfiguratorPage/LinearConfigurator'
import { Route as CheckoutMultiSummaryViewRouteImport } from './routes/checkout/multi/summary/view'
import { Route as MyCompanyOrganizationManagementManageUsersIndexRouteImport } from './routes/my-company/organization-management/manage-users/index'
import { Route as MyCompanyOrganizationManagementManageUsersCreateRouteImport } from './routes/my-company/organization-management/manage-users/create'
import { Route as MyCompanyOrganizationManagementManageUsersEditRouteImport } from './routes/my-company/organization-management/manage-users/edit'
import { Route as RailsProductCodeRailsConfiguratorPageLinearConfiguratorRouteImport } from './routes/rails/$productCode/railsConfiguratorPage/LinearConfigurator'
import { Route as ShaftProductCodeShaftConfiguratorPageLinearConfiguratorRouteImport } from './routes/shaft/$productCode/shaftConfiguratorPage/LinearConfigurator'
import { Route as MyAccountContractDetailsContractCodeMaterialNumberPackCodeContractPositionRouteImport } from './routes/my-account/contractDetails/$contractCode/$materialNumber/$packCode/$contractPosition'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const SplatRoute = SplatRouteImport.update({
  id: '/$',
  path: '/$',
  getParentRoute: () => rootRouteImport,
} as any)
const BearingFrequencyCalculatorRoute =
  BearingFrequencyCalculatorRouteImport.update({
    id: '/bearing-frequency-calculator',
    path: '/bearing-frequency-calculator',
    getParentRoute: () => rootRouteImport,
  } as any)
const BecomeSchaefflerCustomerRoute =
  BecomeSchaefflerCustomerRouteImport.update({
    id: '/become-schaeffler-customer',
    path: '/become-schaeffler-customer',
    getParentRoute: () => rootRouteImport,
  } as any)
const CampaignRoute = CampaignRouteImport.update({
  id: '/campaign',
  path: '/campaign',
  getParentRoute: () => rootRouteImport,
} as any)
const ContactUsRoute = ContactUsRouteImport.update({
  id: '/contact-us',
  path: '/contact-us',
  getParentRoute: () => rootRouteImport,
} as any)
const CopySharedWishlistRoute = CopySharedWishlistRouteImport.update({
  id: '/copySharedWishlist',
  path: '/copySharedWishlist',
  getParentRoute: () => rootRouteImport,
} as any)
const CopyWishlistRoute = CopyWishlistRouteImport.update({
  id: '/copyWishlist',
  path: '/copyWishlist',
  getParentRoute: () => rootRouteImport,
} as any)
const DigitalServiceRoute = DigitalServiceRouteImport.update({
  id: '/digitalService',
  path: '/digitalService',
  getParentRoute: () => rootRouteImport,
} as any)
const FreecapacitycockpitRoute = FreecapacitycockpitRouteImport.update({
  id: '/freecapacitycockpit',
  path: '/freecapacitycockpit',
  getParentRoute: () => rootRouteImport,
} as any)
const HousingselectionassistantRoute =
  HousingselectionassistantRouteImport.update({
    id: '/housingselectionassistant',
    path: '/housingselectionassistant',
    getParentRoute: () => rootRouteImport,
  } as any)
const LubricationSelectionAssistantRoute =
  LubricationSelectionAssistantRouteImport.update({
    id: '/lubrication-selection-assistant',
    path: '/lubrication-selection-assistant',
    getParentRoute: () => rootRouteImport,
  } as any)
const MediaLibraryRoute = MediaLibraryRouteImport.update({
  id: '/media-library',
  path: '/media-library',
  getParentRoute: () => rootRouteImport,
} as any)
const OpenOrdersRoute = OpenOrdersRouteImport.update({
  id: '/open-orders',
  path: '/open-orders',
  getParentRoute: () => rootRouteImport,
} as any)
const PreviewContentRoute = PreviewContentRouteImport.update({
  id: '/preview-content',
  path: '/preview-content',
  getParentRoute: () => rootRouteImport,
} as any)
const SavedConfigsRoute = SavedConfigsRouteImport.update({
  id: '/saved-configs',
  path: '/saved-configs',
  getParentRoute: () => rootRouteImport,
} as any)
const ScandmcRoute = ScandmcRouteImport.update({
  id: '/scandmc',
  path: '/scandmc',
  getParentRoute: () => rootRouteImport,
} as any)
const SdsMediaLibraryRoute = SdsMediaLibraryRouteImport.update({
  id: '/sds-media-library',
  path: '/sds-media-library',
  getParentRoute: () => rootRouteImport,
} as any)
const SelectaccountRoute = SelectaccountRouteImport.update({
  id: '/selectaccount',
  path: '/selectaccount',
  getParentRoute: () => rootRouteImport,
} as any)
const SelectionassistantRoute = SelectionassistantRouteImport.update({
  id: '/selectionassistant',
  path: '/selectionassistant',
  getParentRoute: () => rootRouteImport,
} as any)
const StcRoute = StcRouteImport.update({
  id: '/stc',
  path: '/stc',
  getParentRoute: () => rootRouteImport,
} as any)
const WishlistRoute = WishlistRouteImport.update({
  id: '/wishlist',
  path: '/wishlist',
  getParentRoute: () => rootRouteImport,
} as any)
const CCategoryCodeRoute = CCategoryCodeRouteImport.update({
  id: '/c/$categoryCode',
  path: '/c/$categoryCode',
  getParentRoute: () => rootRouteImport,
} as any)
const CartIndexRoute = CartIndexRouteImport.update({
  id: '/cart/',
  path: '/cart/',
  getParentRoute: () => rootRouteImport,
} as any)
const CartRequestRoute = CartRequestRouteImport.update({
  id: '/cart/request',
  path: '/cart/request',
  getParentRoute: () => rootRouteImport,
} as any)
const CartStoreFinderRoute = CartStoreFinderRouteImport.update({
  id: '/cart/store-finder',
  path: '/cart/store-finder',
  getParentRoute: () => rootRouteImport,
} as any)
const DatasheetProductDesignationRoute =
  DatasheetProductDesignationRouteImport.update({
    id: '/datasheet/$productDesignation',
    path: '/datasheet/$productDesignation',
    getParentRoute: () => rootRouteImport,
  } as any)
const EmbeddedProductConfiguratorProductCodeRoute =
  EmbeddedProductConfiguratorProductCodeRouteImport.update({
    id: '/embeddedProductConfigurator/$productCode',
    path: '/embeddedProductConfigurator/$productCode',
    getParentRoute: () => rootRouteImport,
  } as any)
const LmsActivateRoute = LmsActivateRouteImport.update({
  id: '/lms/activate',
  path: '/lms/activate',
  getParentRoute: () => rootRouteImport,
} as any)
const MyAccountIndexRoute = MyAccountIndexRouteImport.update({
  id: '/my-account/',
  path: '/my-account/',
  getParentRoute: () => rootRouteImport,
} as any)
const MyAccountAccountSettingsRoute =
  MyAccountAccountSettingsRouteImport.update({
    id: '/my-account/accountSettings',
    path: '/my-account/accountSettings',
    getParentRoute: () => rootRouteImport,
  } as any)
const MyAccountContractOverviewRoute =
  MyAccountContractOverviewRouteImport.update({
    id: '/my-account/contractOverview',
    path: '/my-account/contractOverview',
    getParentRoute: () => rootRouteImport,
  } as any)
const MyAccountNewContractRoute = MyAccountNewContractRouteImport.update({
  id: '/my-account/new-contract',
  path: '/my-account/new-contract',
  getParentRoute: () => rootRouteImport,
} as any)
const MyAccountOrderAndQuoteSettingsRoute =
  MyAccountOrderAndQuoteSettingsRouteImport.update({
    id: '/my-account/orderAndQuoteSettings',
    path: '/my-account/orderAndQuoteSettings',
    getParentRoute: () => rootRouteImport,
  } as any)
const NotificationsIndexRoute = NotificationsIndexRouteImport.update({
  id: '/notifications/',
  path: '/notifications/',
  getParentRoute: () => rootRouteImport,
} as any)
const NotificationsSettingsRoute = NotificationsSettingsRouteImport.update({
  id: '/notifications/settings',
  path: '/notifications/settings',
  getParentRoute: () => rootRouteImport,
} as any)
const OrdersIndexRoute = OrdersIndexRouteImport.update({
  id: '/orders/',
  path: '/orders/',
  getParentRoute: () => rootRouteImport,
} as any)
const OrdersIdRoute = OrdersIdRouteImport.update({
  id: '/orders/$id',
  path: '/orders/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const PProductCodeRoute = PProductCodeRouteImport.update({
  id: '/p/$productCode',
  path: '/p/$productCode',
  getParentRoute: () => rootRouteImport,
} as any)
const PlpCategoryCodeRoute = PlpCategoryCodeRouteImport.update({
  id: '/plp/$categoryCode',
  path: '/plp/$categoryCode',
  getParentRoute: () => rootRouteImport,
} as any)
const QuoteIndexRoute = QuoteIndexRouteImport.update({
  id: '/quote/',
  path: '/quote/',
  getParentRoute: () => rootRouteImport,
} as any)
const QuotesIndexRoute = QuotesIndexRouteImport.update({
  id: '/quotes/',
  path: '/quotes/',
  getParentRoute: () => rootRouteImport,
} as any)
const QuotesIdRoute = QuotesIdRouteImport.update({
  id: '/quotes/$id',
  path: '/quotes/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const RequestLinearConfigurationQuoteConfirmationRoute =
  RequestLinearConfigurationQuoteConfirmationRouteImport.update({
    id: '/requestLinearConfigurationQuote/confirmation',
    path: '/requestLinearConfigurationQuote/confirmation',
    getParentRoute: () => rootRouteImport,
  } as any)
const SavedConfiguratorCodeRoute = SavedConfiguratorCodeRouteImport.update({
  id: '/savedConfigurator/$code',
  path: '/savedConfigurator/$code',
  getParentRoute: () => rootRouteImport,
} as any)
const SearchIndexRoute = SearchIndexRouteImport.update({
  id: '/search/',
  path: '/search/',
  getParentRoute: () => rootRouteImport,
} as any)
const SearchSearchpageRoute = SearchSearchpageRouteImport.update({
  id: '/search/searchpage',
  path: '/search/searchpage',
  getParentRoute: () => rootRouteImport,
} as any)
const SendLinearConfigurationsViaEmailConfirmationRoute =
  SendLinearConfigurationsViaEmailConfirmationRouteImport.update({
    id: '/sendLinearConfigurationsViaEmail/confirmation',
    path: '/sendLinearConfigurationsViaEmail/confirmation',
    getParentRoute: () => rootRouteImport,
  } as any)
const SendWishlistViaEmailConfirmationRoute =
  SendWishlistViaEmailConfirmationRouteImport.update({
    id: '/sendWishlistViaEmail/confirmation',
    path: '/sendWishlistViaEmail/confirmation',
    getParentRoute: () => rootRouteImport,
  } as any)
const StaticWelcomeRoute = StaticWelcomeRouteImport.update({
  id: '/static/welcome',
  path: '/static/welcome',
  getParentRoute: () => rootRouteImport,
} as any)
const StoreFinderIndexRoute = StoreFinderIndexRouteImport.update({
  id: '/store-finder/',
  path: '/store-finder/',
  getParentRoute: () => rootRouteImport,
} as any)
const StoreFinderConfirmationRoute = StoreFinderConfirmationRouteImport.update({
  id: '/store-finder/confirmation',
  path: '/store-finder/confirmation',
  getParentRoute: () => rootRouteImport,
} as any)
const ProductCodeConfiguratorPageLinearConfiguratorRoute =
  ProductCodeConfiguratorPageLinearConfiguratorRouteImport.update({
    id: '/$productCode/configuratorPage/LinearConfigurator',
    path: '/$productCode/configuratorPage/LinearConfigurator',
    getParentRoute: () => rootRouteImport,
  } as any)
const CheckoutOrderConfirmationReferenceCodeRoute =
  CheckoutOrderConfirmationReferenceCodeRouteImport.update({
    id: '/checkout/orderConfirmation/$referenceCode',
    path: '/checkout/orderConfirmation/$referenceCode',
    getParentRoute: () => rootRouteImport,
  } as any)
const LoginPwChangeRoute = LoginPwChangeRouteImport.update({
  id: '/login/pw/change',
  path: '/login/pw/change',
  getParentRoute: () => rootRouteImport,
} as any)
const QuoteConfirmIndexRoute = QuoteConfirmIndexRouteImport.update({
  id: '/quote/confirm/',
  path: '/quote/confirm/',
  getParentRoute: () => rootRouteImport,
} as any)
const QuoteConfirmOrderCodeRoute = QuoteConfirmOrderCodeRouteImport.update({
  id: '/quote/confirm/$orderCode',
  path: '/quote/confirm/$orderCode',
  getParentRoute: () => rootRouteImport,
} as any)
const RegisteredUserIndexRoute = RegisteredUserIndexRouteImport.update({
  id: '/registered/user/',
  path: '/registered/user/',
  getParentRoute: () => rootRouteImport,
} as any)
const RegisteredUserConfirmationRoute =
  RegisteredUserConfirmationRouteImport.update({
    id: '/registered/user/confirmation',
    path: '/registered/user/confirmation',
    getParentRoute: () => rootRouteImport,
  } as any)
const CarriagesProductCodeCarriagesConfiguratorPageLinearConfiguratorRoute =
  CarriagesProductCodeCarriagesConfiguratorPageLinearConfiguratorRouteImport.update(
    {
      id: '/carriages/$productCode/carriagesConfiguratorPage/LinearConfigurator',
      path: '/carriages/$productCode/carriagesConfiguratorPage/LinearConfigurator',
      getParentRoute: () => rootRouteImport,
    } as any,
  )
const CheckoutMultiSummaryViewRoute =
  CheckoutMultiSummaryViewRouteImport.update({
    id: '/checkout/multi/summary/view',
    path: '/checkout/multi/summary/view',
    getParentRoute: () => rootRouteImport,
  } as any)
const MyCompanyOrganizationManagementManageUsersIndexRoute =
  MyCompanyOrganizationManagementManageUsersIndexRouteImport.update({
    id: '/my-company/organization-management/manage-users/',
    path: '/my-company/organization-management/manage-users/',
    getParentRoute: () => rootRouteImport,
  } as any)
const MyCompanyOrganizationManagementManageUsersCreateRoute =
  MyCompanyOrganizationManagementManageUsersCreateRouteImport.update({
    id: '/my-company/organization-management/manage-users/create',
    path: '/my-company/organization-management/manage-users/create',
    getParentRoute: () => rootRouteImport,
  } as any)
const MyCompanyOrganizationManagementManageUsersEditRoute =
  MyCompanyOrganizationManagementManageUsersEditRouteImport.update({
    id: '/my-company/organization-management/manage-users/edit',
    path: '/my-company/organization-management/manage-users/edit',
    getParentRoute: () => rootRouteImport,
  } as any)
const RailsProductCodeRailsConfiguratorPageLinearConfiguratorRoute =
  RailsProductCodeRailsConfiguratorPageLinearConfiguratorRouteImport.update({
    id: '/rails/$productCode/railsConfiguratorPage/LinearConfigurator',
    path: '/rails/$productCode/railsConfiguratorPage/LinearConfigurator',
    getParentRoute: () => rootRouteImport,
  } as any)
const ShaftProductCodeShaftConfiguratorPageLinearConfiguratorRoute =
  ShaftProductCodeShaftConfiguratorPageLinearConfiguratorRouteImport.update({
    id: '/shaft/$productCode/shaftConfiguratorPage/LinearConfigurator',
    path: '/shaft/$productCode/shaftConfiguratorPage/LinearConfigurator',
    getParentRoute: () => rootRouteImport,
  } as any)
const MyAccountContractDetailsContractCodeMaterialNumberPackCodeContractPositionRoute =
  MyAccountContractDetailsContractCodeMaterialNumberPackCodeContractPositionRouteImport.update(
    {
      id: '/my-account/contractDetails/$contractCode/$materialNumber/$packCode/$contractPosition',
      path: '/my-account/contractDetails/$contractCode/$materialNumber/$packCode/$contractPosition',
      getParentRoute: () => rootRouteImport,
    } as any,
  )

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/$': typeof SplatRoute
  '/bearing-frequency-calculator': typeof BearingFrequencyCalculatorRoute
  '/become-schaeffler-customer': typeof BecomeSchaefflerCustomerRoute
  '/campaign': typeof CampaignRoute
  '/contact-us': typeof ContactUsRoute
  '/copySharedWishlist': typeof CopySharedWishlistRoute
  '/copyWishlist': typeof CopyWishlistRoute
  '/digitalService': typeof DigitalServiceRoute
  '/freecapacitycockpit': typeof FreecapacitycockpitRoute
  '/housingselectionassistant': typeof HousingselectionassistantRoute
  '/lubrication-selection-assistant': typeof LubricationSelectionAssistantRoute
  '/media-library': typeof MediaLibraryRoute
  '/open-orders': typeof OpenOrdersRoute
  '/preview-content': typeof PreviewContentRoute
  '/saved-configs': typeof SavedConfigsRoute
  '/scandmc': typeof ScandmcRoute
  '/sds-media-library': typeof SdsMediaLibraryRoute
  '/selectaccount': typeof SelectaccountRoute
  '/selectionassistant': typeof SelectionassistantRoute
  '/stc': typeof StcRoute
  '/wishlist': typeof WishlistRoute
  '/c/$categoryCode': typeof CCategoryCodeRoute
  '/cart/request': typeof CartRequestRoute
  '/cart/store-finder': typeof CartStoreFinderRoute
  '/datasheet/$productDesignation': typeof DatasheetProductDesignationRoute
  '/embeddedProductConfigurator/$productCode': typeof EmbeddedProductConfiguratorProductCodeRoute
  '/lms/activate': typeof LmsActivateRoute
  '/my-account/accountSettings': typeof MyAccountAccountSettingsRoute
  '/my-account/contractOverview': typeof MyAccountContractOverviewRoute
  '/my-account/new-contract': typeof MyAccountNewContractRoute
  '/my-account/orderAndQuoteSettings': typeof MyAccountOrderAndQuoteSettingsRoute
  '/notifications/settings': typeof NotificationsSettingsRoute
  '/orders/$id': typeof OrdersIdRoute
  '/p/$productCode': typeof PProductCodeRoute
  '/plp/$categoryCode': typeof PlpCategoryCodeRoute
  '/quotes/$id': typeof QuotesIdRoute
  '/requestLinearConfigurationQuote/confirmation': typeof RequestLinearConfigurationQuoteConfirmationRoute
  '/savedConfigurator/$code': typeof SavedConfiguratorCodeRoute
  '/search/searchpage': typeof SearchSearchpageRoute
  '/sendLinearConfigurationsViaEmail/confirmation': typeof SendLinearConfigurationsViaEmailConfirmationRoute
  '/sendWishlistViaEmail/confirmation': typeof SendWishlistViaEmailConfirmationRoute
  '/static/welcome': typeof StaticWelcomeRoute
  '/store-finder/confirmation': typeof StoreFinderConfirmationRoute
  '/cart/': typeof CartIndexRoute
  '/my-account/': typeof MyAccountIndexRoute
  '/notifications/': typeof NotificationsIndexRoute
  '/orders/': typeof OrdersIndexRoute
  '/quote/': typeof QuoteIndexRoute
  '/quotes/': typeof QuotesIndexRoute
  '/search/': typeof SearchIndexRoute
  '/store-finder/': typeof StoreFinderIndexRoute
  '/$productCode/configuratorPage/LinearConfigurator': typeof ProductCodeConfiguratorPageLinearConfiguratorRoute
  '/checkout/orderConfirmation/$referenceCode': typeof CheckoutOrderConfirmationReferenceCodeRoute
  '/login/pw/change': typeof LoginPwChangeRoute
  '/quote/confirm/$orderCode': typeof QuoteConfirmOrderCodeRoute
  '/registered/user/confirmation': typeof RegisteredUserConfirmationRoute
  '/quote/confirm/': typeof QuoteConfirmIndexRoute
  '/registered/user/': typeof RegisteredUserIndexRoute
  '/carriages/$productCode/carriagesConfiguratorPage/LinearConfigurator': typeof CarriagesProductCodeCarriagesConfiguratorPageLinearConfiguratorRoute
  '/checkout/multi/summary/view': typeof CheckoutMultiSummaryViewRoute
  '/my-company/organization-management/manage-users/create': typeof MyCompanyOrganizationManagementManageUsersCreateRoute
  '/my-company/organization-management/manage-users/edit': typeof MyCompanyOrganizationManagementManageUsersEditRoute
  '/rails/$productCode/railsConfiguratorPage/LinearConfigurator': typeof RailsProductCodeRailsConfiguratorPageLinearConfiguratorRoute
  '/shaft/$productCode/shaftConfiguratorPage/LinearConfigurator': typeof ShaftProductCodeShaftConfiguratorPageLinearConfiguratorRoute
  '/my-company/organization-management/manage-users/': typeof MyCompanyOrganizationManagementManageUsersIndexRoute
  '/my-account/contractDetails/$contractCode/$materialNumber/$packCode/$contractPosition': typeof MyAccountContractDetailsContractCodeMaterialNumberPackCodeContractPositionRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/$': typeof SplatRoute
  '/bearing-frequency-calculator': typeof BearingFrequencyCalculatorRoute
  '/become-schaeffler-customer': typeof BecomeSchaefflerCustomerRoute
  '/campaign': typeof CampaignRoute
  '/contact-us': typeof ContactUsRoute
  '/copySharedWishlist': typeof CopySharedWishlistRoute
  '/copyWishlist': typeof CopyWishlistRoute
  '/digitalService': typeof DigitalServiceRoute
  '/freecapacitycockpit': typeof FreecapacitycockpitRoute
  '/housingselectionassistant': typeof HousingselectionassistantRoute
  '/lubrication-selection-assistant': typeof LubricationSelectionAssistantRoute
  '/media-library': typeof MediaLibraryRoute
  '/open-orders': typeof OpenOrdersRoute
  '/preview-content': typeof PreviewContentRoute
  '/saved-configs': typeof SavedConfigsRoute
  '/scandmc': typeof ScandmcRoute
  '/sds-media-library': typeof SdsMediaLibraryRoute
  '/selectaccount': typeof SelectaccountRoute
  '/selectionassistant': typeof SelectionassistantRoute
  '/stc': typeof StcRoute
  '/wishlist': typeof WishlistRoute
  '/c/$categoryCode': typeof CCategoryCodeRoute
  '/cart/request': typeof CartRequestRoute
  '/cart/store-finder': typeof CartStoreFinderRoute
  '/datasheet/$productDesignation': typeof DatasheetProductDesignationRoute
  '/embeddedProductConfigurator/$productCode': typeof EmbeddedProductConfiguratorProductCodeRoute
  '/lms/activate': typeof LmsActivateRoute
  '/my-account/accountSettings': typeof MyAccountAccountSettingsRoute
  '/my-account/contractOverview': typeof MyAccountContractOverviewRoute
  '/my-account/new-contract': typeof MyAccountNewContractRoute
  '/my-account/orderAndQuoteSettings': typeof MyAccountOrderAndQuoteSettingsRoute
  '/notifications/settings': typeof NotificationsSettingsRoute
  '/orders/$id': typeof OrdersIdRoute
  '/p/$productCode': typeof PProductCodeRoute
  '/plp/$categoryCode': typeof PlpCategoryCodeRoute
  '/quotes/$id': typeof QuotesIdRoute
  '/requestLinearConfigurationQuote/confirmation': typeof RequestLinearConfigurationQuoteConfirmationRoute
  '/savedConfigurator/$code': typeof SavedConfiguratorCodeRoute
  '/search/searchpage': typeof SearchSearchpageRoute
  '/sendLinearConfigurationsViaEmail/confirmation': typeof SendLinearConfigurationsViaEmailConfirmationRoute
  '/sendWishlistViaEmail/confirmation': typeof SendWishlistViaEmailConfirmationRoute
  '/static/welcome': typeof StaticWelcomeRoute
  '/store-finder/confirmation': typeof StoreFinderConfirmationRoute
  '/cart': typeof CartIndexRoute
  '/my-account': typeof MyAccountIndexRoute
  '/notifications': typeof NotificationsIndexRoute
  '/orders': typeof OrdersIndexRoute
  '/quote': typeof QuoteIndexRoute
  '/quotes': typeof QuotesIndexRoute
  '/search': typeof SearchIndexRoute
  '/store-finder': typeof StoreFinderIndexRoute
  '/$productCode/configuratorPage/LinearConfigurator': typeof ProductCodeConfiguratorPageLinearConfiguratorRoute
  '/checkout/orderConfirmation/$referenceCode': typeof CheckoutOrderConfirmationReferenceCodeRoute
  '/login/pw/change': typeof LoginPwChangeRoute
  '/quote/confirm/$orderCode': typeof QuoteConfirmOrderCodeRoute
  '/registered/user/confirmation': typeof RegisteredUserConfirmationRoute
  '/quote/confirm': typeof QuoteConfirmIndexRoute
  '/registered/user': typeof RegisteredUserIndexRoute
  '/carriages/$productCode/carriagesConfiguratorPage/LinearConfigurator': typeof CarriagesProductCodeCarriagesConfiguratorPageLinearConfiguratorRoute
  '/checkout/multi/summary/view': typeof CheckoutMultiSummaryViewRoute
  '/my-company/organization-management/manage-users/create': typeof MyCompanyOrganizationManagementManageUsersCreateRoute
  '/my-company/organization-management/manage-users/edit': typeof MyCompanyOrganizationManagementManageUsersEditRoute
  '/rails/$productCode/railsConfiguratorPage/LinearConfigurator': typeof RailsProductCodeRailsConfiguratorPageLinearConfiguratorRoute
  '/shaft/$productCode/shaftConfiguratorPage/LinearConfigurator': typeof ShaftProductCodeShaftConfiguratorPageLinearConfiguratorRoute
  '/my-company/organization-management/manage-users': typeof MyCompanyOrganizationManagementManageUsersIndexRoute
  '/my-account/contractDetails/$contractCode/$materialNumber/$packCode/$contractPosition': typeof MyAccountContractDetailsContractCodeMaterialNumberPackCodeContractPositionRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/$': typeof SplatRoute
  '/bearing-frequency-calculator': typeof BearingFrequencyCalculatorRoute
  '/become-schaeffler-customer': typeof BecomeSchaefflerCustomerRoute
  '/campaign': typeof CampaignRoute
  '/contact-us': typeof ContactUsRoute
  '/copySharedWishlist': typeof CopySharedWishlistRoute
  '/copyWishlist': typeof CopyWishlistRoute
  '/digitalService': typeof DigitalServiceRoute
  '/freecapacitycockpit': typeof FreecapacitycockpitRoute
  '/housingselectionassistant': typeof HousingselectionassistantRoute
  '/lubrication-selection-assistant': typeof LubricationSelectionAssistantRoute
  '/media-library': typeof MediaLibraryRoute
  '/open-orders': typeof OpenOrdersRoute
  '/preview-content': typeof PreviewContentRoute
  '/saved-configs': typeof SavedConfigsRoute
  '/scandmc': typeof ScandmcRoute
  '/sds-media-library': typeof SdsMediaLibraryRoute
  '/selectaccount': typeof SelectaccountRoute
  '/selectionassistant': typeof SelectionassistantRoute
  '/stc': typeof StcRoute
  '/wishlist': typeof WishlistRoute
  '/c/$categoryCode': typeof CCategoryCodeRoute
  '/cart/request': typeof CartRequestRoute
  '/cart/store-finder': typeof CartStoreFinderRoute
  '/datasheet/$productDesignation': typeof DatasheetProductDesignationRoute
  '/embeddedProductConfigurator/$productCode': typeof EmbeddedProductConfiguratorProductCodeRoute
  '/lms/activate': typeof LmsActivateRoute
  '/my-account/accountSettings': typeof MyAccountAccountSettingsRoute
  '/my-account/contractOverview': typeof MyAccountContractOverviewRoute
  '/my-account/new-contract': typeof MyAccountNewContractRoute
  '/my-account/orderAndQuoteSettings': typeof MyAccountOrderAndQuoteSettingsRoute
  '/notifications/settings': typeof NotificationsSettingsRoute
  '/orders/$id': typeof OrdersIdRoute
  '/p/$productCode': typeof PProductCodeRoute
  '/plp/$categoryCode': typeof PlpCategoryCodeRoute
  '/quotes/$id': typeof QuotesIdRoute
  '/requestLinearConfigurationQuote/confirmation': typeof RequestLinearConfigurationQuoteConfirmationRoute
  '/savedConfigurator/$code': typeof SavedConfiguratorCodeRoute
  '/search/searchpage': typeof SearchSearchpageRoute
  '/sendLinearConfigurationsViaEmail/confirmation': typeof SendLinearConfigurationsViaEmailConfirmationRoute
  '/sendWishlistViaEmail/confirmation': typeof SendWishlistViaEmailConfirmationRoute
  '/static/welcome': typeof StaticWelcomeRoute
  '/store-finder/confirmation': typeof StoreFinderConfirmationRoute
  '/cart/': typeof CartIndexRoute
  '/my-account/': typeof MyAccountIndexRoute
  '/notifications/': typeof NotificationsIndexRoute
  '/orders/': typeof OrdersIndexRoute
  '/quote/': typeof QuoteIndexRoute
  '/quotes/': typeof QuotesIndexRoute
  '/search/': typeof SearchIndexRoute
  '/store-finder/': typeof StoreFinderIndexRoute
  '/$productCode/configuratorPage/LinearConfigurator': typeof ProductCodeConfiguratorPageLinearConfiguratorRoute
  '/checkout/orderConfirmation/$referenceCode': typeof CheckoutOrderConfirmationReferenceCodeRoute
  '/login/pw/change': typeof LoginPwChangeRoute
  '/quote/confirm/$orderCode': typeof QuoteConfirmOrderCodeRoute
  '/registered/user/confirmation': typeof RegisteredUserConfirmationRoute
  '/quote/confirm/': typeof QuoteConfirmIndexRoute
  '/registered/user/': typeof RegisteredUserIndexRoute
  '/carriages/$productCode/carriagesConfiguratorPage/LinearConfigurator': typeof CarriagesProductCodeCarriagesConfiguratorPageLinearConfiguratorRoute
  '/checkout/multi/summary/view': typeof CheckoutMultiSummaryViewRoute
  '/my-company/organization-management/manage-users/create': typeof MyCompanyOrganizationManagementManageUsersCreateRoute
  '/my-company/organization-management/manage-users/edit': typeof MyCompanyOrganizationManagementManageUsersEditRoute
  '/rails/$productCode/railsConfiguratorPage/LinearConfigurator': typeof RailsProductCodeRailsConfiguratorPageLinearConfiguratorRoute
  '/shaft/$productCode/shaftConfiguratorPage/LinearConfigurator': typeof ShaftProductCodeShaftConfiguratorPageLinearConfiguratorRoute
  '/my-company/organization-management/manage-users/': typeof MyCompanyOrganizationManagementManageUsersIndexRoute
  '/my-account/contractDetails/$contractCode/$materialNumber/$packCode/$contractPosition': typeof MyAccountContractDetailsContractCodeMaterialNumberPackCodeContractPositionRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/$'
    | '/bearing-frequency-calculator'
    | '/become-schaeffler-customer'
    | '/campaign'
    | '/contact-us'
    | '/copySharedWishlist'
    | '/copyWishlist'
    | '/digitalService'
    | '/freecapacitycockpit'
    | '/housingselectionassistant'
    | '/lubrication-selection-assistant'
    | '/media-library'
    | '/open-orders'
    | '/preview-content'
    | '/saved-configs'
    | '/scandmc'
    | '/sds-media-library'
    | '/selectaccount'
    | '/selectionassistant'
    | '/stc'
    | '/wishlist'
    | '/c/$categoryCode'
    | '/cart/request'
    | '/cart/store-finder'
    | '/datasheet/$productDesignation'
    | '/embeddedProductConfigurator/$productCode'
    | '/lms/activate'
    | '/my-account/accountSettings'
    | '/my-account/contractOverview'
    | '/my-account/new-contract'
    | '/my-account/orderAndQuoteSettings'
    | '/notifications/settings'
    | '/orders/$id'
    | '/p/$productCode'
    | '/plp/$categoryCode'
    | '/quotes/$id'
    | '/requestLinearConfigurationQuote/confirmation'
    | '/savedConfigurator/$code'
    | '/search/searchpage'
    | '/sendLinearConfigurationsViaEmail/confirmation'
    | '/sendWishlistViaEmail/confirmation'
    | '/static/welcome'
    | '/store-finder/confirmation'
    | '/cart/'
    | '/my-account/'
    | '/notifications/'
    | '/orders/'
    | '/quote/'
    | '/quotes/'
    | '/search/'
    | '/store-finder/'
    | '/$productCode/configuratorPage/LinearConfigurator'
    | '/checkout/orderConfirmation/$referenceCode'
    | '/login/pw/change'
    | '/quote/confirm/$orderCode'
    | '/registered/user/confirmation'
    | '/quote/confirm/'
    | '/registered/user/'
    | '/carriages/$productCode/carriagesConfiguratorPage/LinearConfigurator'
    | '/checkout/multi/summary/view'
    | '/my-company/organization-management/manage-users/create'
    | '/my-company/organization-management/manage-users/edit'
    | '/rails/$productCode/railsConfiguratorPage/LinearConfigurator'
    | '/shaft/$productCode/shaftConfiguratorPage/LinearConfigurator'
    | '/my-company/organization-management/manage-users/'
    | '/my-account/contractDetails/$contractCode/$materialNumber/$packCode/$contractPosition'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/$'
    | '/bearing-frequency-calculator'
    | '/become-schaeffler-customer'
    | '/campaign'
    | '/contact-us'
    | '/copySharedWishlist'
    | '/copyWishlist'
    | '/digitalService'
    | '/freecapacitycockpit'
    | '/housingselectionassistant'
    | '/lubrication-selection-assistant'
    | '/media-library'
    | '/open-orders'
    | '/preview-content'
    | '/saved-configs'
    | '/scandmc'
    | '/sds-media-library'
    | '/selectaccount'
    | '/selectionassistant'
    | '/stc'
    | '/wishlist'
    | '/c/$categoryCode'
    | '/cart/request'
    | '/cart/store-finder'
    | '/datasheet/$productDesignation'
    | '/embeddedProductConfigurator/$productCode'
    | '/lms/activate'
    | '/my-account/accountSettings'
    | '/my-account/contractOverview'
    | '/my-account/new-contract'
    | '/my-account/orderAndQuoteSettings'
    | '/notifications/settings'
    | '/orders/$id'
    | '/p/$productCode'
    | '/plp/$categoryCode'
    | '/quotes/$id'
    | '/requestLinearConfigurationQuote/confirmation'
    | '/savedConfigurator/$code'
    | '/search/searchpage'
    | '/sendLinearConfigurationsViaEmail/confirmation'
    | '/sendWishlistViaEmail/confirmation'
    | '/static/welcome'
    | '/store-finder/confirmation'
    | '/cart'
    | '/my-account'
    | '/notifications'
    | '/orders'
    | '/quote'
    | '/quotes'
    | '/search'
    | '/store-finder'
    | '/$productCode/configuratorPage/LinearConfigurator'
    | '/checkout/orderConfirmation/$referenceCode'
    | '/login/pw/change'
    | '/quote/confirm/$orderCode'
    | '/registered/user/confirmation'
    | '/quote/confirm'
    | '/registered/user'
    | '/carriages/$productCode/carriagesConfiguratorPage/LinearConfigurator'
    | '/checkout/multi/summary/view'
    | '/my-company/organization-management/manage-users/create'
    | '/my-company/organization-management/manage-users/edit'
    | '/rails/$productCode/railsConfiguratorPage/LinearConfigurator'
    | '/shaft/$productCode/shaftConfiguratorPage/LinearConfigurator'
    | '/my-company/organization-management/manage-users'
    | '/my-account/contractDetails/$contractCode/$materialNumber/$packCode/$contractPosition'
  id:
    | '__root__'
    | '/'
    | '/$'
    | '/bearing-frequency-calculator'
    | '/become-schaeffler-customer'
    | '/campaign'
    | '/contact-us'
    | '/copySharedWishlist'
    | '/copyWishlist'
    | '/digitalService'
    | '/freecapacitycockpit'
    | '/housingselectionassistant'
    | '/lubrication-selection-assistant'
    | '/media-library'
    | '/open-orders'
    | '/preview-content'
    | '/saved-configs'
    | '/scandmc'
    | '/sds-media-library'
    | '/selectaccount'
    | '/selectionassistant'
    | '/stc'
    | '/wishlist'
    | '/c/$categoryCode'
    | '/cart/request'
    | '/cart/store-finder'
    | '/datasheet/$productDesignation'
    | '/embeddedProductConfigurator/$productCode'
    | '/lms/activate'
    | '/my-account/accountSettings'
    | '/my-account/contractOverview'
    | '/my-account/new-contract'
    | '/my-account/orderAndQuoteSettings'
    | '/notifications/settings'
    | '/orders/$id'
    | '/p/$productCode'
    | '/plp/$categoryCode'
    | '/quotes/$id'
    | '/requestLinearConfigurationQuote/confirmation'
    | '/savedConfigurator/$code'
    | '/search/searchpage'
    | '/sendLinearConfigurationsViaEmail/confirmation'
    | '/sendWishlistViaEmail/confirmation'
    | '/static/welcome'
    | '/store-finder/confirmation'
    | '/cart/'
    | '/my-account/'
    | '/notifications/'
    | '/orders/'
    | '/quote/'
    | '/quotes/'
    | '/search/'
    | '/store-finder/'
    | '/$productCode/configuratorPage/LinearConfigurator'
    | '/checkout/orderConfirmation/$referenceCode'
    | '/login/pw/change'
    | '/quote/confirm/$orderCode'
    | '/registered/user/confirmation'
    | '/quote/confirm/'
    | '/registered/user/'
    | '/carriages/$productCode/carriagesConfiguratorPage/LinearConfigurator'
    | '/checkout/multi/summary/view'
    | '/my-company/organization-management/manage-users/create'
    | '/my-company/organization-management/manage-users/edit'
    | '/rails/$productCode/railsConfiguratorPage/LinearConfigurator'
    | '/shaft/$productCode/shaftConfiguratorPage/LinearConfigurator'
    | '/my-company/organization-management/manage-users/'
    | '/my-account/contractDetails/$contractCode/$materialNumber/$packCode/$contractPosition'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  SplatRoute: typeof SplatRoute
  BearingFrequencyCalculatorRoute: typeof BearingFrequencyCalculatorRoute
  BecomeSchaefflerCustomerRoute: typeof BecomeSchaefflerCustomerRoute
  CampaignRoute: typeof CampaignRoute
  ContactUsRoute: typeof ContactUsRoute
  CopySharedWishlistRoute: typeof CopySharedWishlistRoute
  CopyWishlistRoute: typeof CopyWishlistRoute
  DigitalServiceRoute: typeof DigitalServiceRoute
  FreecapacitycockpitRoute: typeof FreecapacitycockpitRoute
  HousingselectionassistantRoute: typeof HousingselectionassistantRoute
  LubricationSelectionAssistantRoute: typeof LubricationSelectionAssistantRoute
  MediaLibraryRoute: typeof MediaLibraryRoute
  OpenOrdersRoute: typeof OpenOrdersRoute
  PreviewContentRoute: typeof PreviewContentRoute
  SavedConfigsRoute: typeof SavedConfigsRoute
  ScandmcRoute: typeof ScandmcRoute
  SdsMediaLibraryRoute: typeof SdsMediaLibraryRoute
  SelectaccountRoute: typeof SelectaccountRoute
  SelectionassistantRoute: typeof SelectionassistantRoute
  StcRoute: typeof StcRoute
  WishlistRoute: typeof WishlistRoute
  CCategoryCodeRoute: typeof CCategoryCodeRoute
  CartRequestRoute: typeof CartRequestRoute
  CartStoreFinderRoute: typeof CartStoreFinderRoute
  DatasheetProductDesignationRoute: typeof DatasheetProductDesignationRoute
  EmbeddedProductConfiguratorProductCodeRoute: typeof EmbeddedProductConfiguratorProductCodeRoute
  LmsActivateRoute: typeof LmsActivateRoute
  MyAccountAccountSettingsRoute: typeof MyAccountAccountSettingsRoute
  MyAccountContractOverviewRoute: typeof MyAccountContractOverviewRoute
  MyAccountNewContractRoute: typeof MyAccountNewContractRoute
  MyAccountOrderAndQuoteSettingsRoute: typeof MyAccountOrderAndQuoteSettingsRoute
  NotificationsSettingsRoute: typeof NotificationsSettingsRoute
  OrdersIdRoute: typeof OrdersIdRoute
  PProductCodeRoute: typeof PProductCodeRoute
  PlpCategoryCodeRoute: typeof PlpCategoryCodeRoute
  QuotesIdRoute: typeof QuotesIdRoute
  RequestLinearConfigurationQuoteConfirmationRoute: typeof RequestLinearConfigurationQuoteConfirmationRoute
  SavedConfiguratorCodeRoute: typeof SavedConfiguratorCodeRoute
  SearchSearchpageRoute: typeof SearchSearchpageRoute
  SendLinearConfigurationsViaEmailConfirmationRoute: typeof SendLinearConfigurationsViaEmailConfirmationRoute
  SendWishlistViaEmailConfirmationRoute: typeof SendWishlistViaEmailConfirmationRoute
  StaticWelcomeRoute: typeof StaticWelcomeRoute
  StoreFinderConfirmationRoute: typeof StoreFinderConfirmationRoute
  CartIndexRoute: typeof CartIndexRoute
  MyAccountIndexRoute: typeof MyAccountIndexRoute
  NotificationsIndexRoute: typeof NotificationsIndexRoute
  OrdersIndexRoute: typeof OrdersIndexRoute
  QuoteIndexRoute: typeof QuoteIndexRoute
  QuotesIndexRoute: typeof QuotesIndexRoute
  SearchIndexRoute: typeof SearchIndexRoute
  StoreFinderIndexRoute: typeof StoreFinderIndexRoute
  ProductCodeConfiguratorPageLinearConfiguratorRoute: typeof ProductCodeConfiguratorPageLinearConfiguratorRoute
  CheckoutOrderConfirmationReferenceCodeRoute: typeof CheckoutOrderConfirmationReferenceCodeRoute
  LoginPwChangeRoute: typeof LoginPwChangeRoute
  QuoteConfirmOrderCodeRoute: typeof QuoteConfirmOrderCodeRoute
  RegisteredUserConfirmationRoute: typeof RegisteredUserConfirmationRoute
  QuoteConfirmIndexRoute: typeof QuoteConfirmIndexRoute
  RegisteredUserIndexRoute: typeof RegisteredUserIndexRoute
  CarriagesProductCodeCarriagesConfiguratorPageLinearConfiguratorRoute: typeof CarriagesProductCodeCarriagesConfiguratorPageLinearConfiguratorRoute
  CheckoutMultiSummaryViewRoute: typeof CheckoutMultiSummaryViewRoute
  MyCompanyOrganizationManagementManageUsersCreateRoute: typeof MyCompanyOrganizationManagementManageUsersCreateRoute
  MyCompanyOrganizationManagementManageUsersEditRoute: typeof MyCompanyOrganizationManagementManageUsersEditRoute
  RailsProductCodeRailsConfiguratorPageLinearConfiguratorRoute: typeof RailsProductCodeRailsConfiguratorPageLinearConfiguratorRoute
  ShaftProductCodeShaftConfiguratorPageLinearConfiguratorRoute: typeof ShaftProductCodeShaftConfiguratorPageLinearConfiguratorRoute
  MyCompanyOrganizationManagementManageUsersIndexRoute: typeof MyCompanyOrganizationManagementManageUsersIndexRoute
  MyAccountContractDetailsContractCodeMaterialNumberPackCodeContractPositionRoute: typeof MyAccountContractDetailsContractCodeMaterialNumberPackCodeContractPositionRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/$': {
      id: '/$'
      path: '/$'
      fullPath: '/$'
      preLoaderRoute: typeof SplatRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/bearing-frequency-calculator': {
      id: '/bearing-frequency-calculator'
      path: '/bearing-frequency-calculator'
      fullPath: '/bearing-frequency-calculator'
      preLoaderRoute: typeof BearingFrequencyCalculatorRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/become-schaeffler-customer': {
      id: '/become-schaeffler-customer'
      path: '/become-schaeffler-customer'
      fullPath: '/become-schaeffler-customer'
      preLoaderRoute: typeof BecomeSchaefflerCustomerRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/campaign': {
      id: '/campaign'
      path: '/campaign'
      fullPath: '/campaign'
      preLoaderRoute: typeof CampaignRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/contact-us': {
      id: '/contact-us'
      path: '/contact-us'
      fullPath: '/contact-us'
      preLoaderRoute: typeof ContactUsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/copySharedWishlist': {
      id: '/copySharedWishlist'
      path: '/copySharedWishlist'
      fullPath: '/copySharedWishlist'
      preLoaderRoute: typeof CopySharedWishlistRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/copyWishlist': {
      id: '/copyWishlist'
      path: '/copyWishlist'
      fullPath: '/copyWishlist'
      preLoaderRoute: typeof CopyWishlistRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/digitalService': {
      id: '/digitalService'
      path: '/digitalService'
      fullPath: '/digitalService'
      preLoaderRoute: typeof DigitalServiceRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/freecapacitycockpit': {
      id: '/freecapacitycockpit'
      path: '/freecapacitycockpit'
      fullPath: '/freecapacitycockpit'
      preLoaderRoute: typeof FreecapacitycockpitRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/housingselectionassistant': {
      id: '/housingselectionassistant'
      path: '/housingselectionassistant'
      fullPath: '/housingselectionassistant'
      preLoaderRoute: typeof HousingselectionassistantRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/lubrication-selection-assistant': {
      id: '/lubrication-selection-assistant'
      path: '/lubrication-selection-assistant'
      fullPath: '/lubrication-selection-assistant'
      preLoaderRoute: typeof LubricationSelectionAssistantRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/media-library': {
      id: '/media-library'
      path: '/media-library'
      fullPath: '/media-library'
      preLoaderRoute: typeof MediaLibraryRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/open-orders': {
      id: '/open-orders'
      path: '/open-orders'
      fullPath: '/open-orders'
      preLoaderRoute: typeof OpenOrdersRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/preview-content': {
      id: '/preview-content'
      path: '/preview-content'
      fullPath: '/preview-content'
      preLoaderRoute: typeof PreviewContentRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/saved-configs': {
      id: '/saved-configs'
      path: '/saved-configs'
      fullPath: '/saved-configs'
      preLoaderRoute: typeof SavedConfigsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/scandmc': {
      id: '/scandmc'
      path: '/scandmc'
      fullPath: '/scandmc'
      preLoaderRoute: typeof ScandmcRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sds-media-library': {
      id: '/sds-media-library'
      path: '/sds-media-library'
      fullPath: '/sds-media-library'
      preLoaderRoute: typeof SdsMediaLibraryRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/selectaccount': {
      id: '/selectaccount'
      path: '/selectaccount'
      fullPath: '/selectaccount'
      preLoaderRoute: typeof SelectaccountRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/selectionassistant': {
      id: '/selectionassistant'
      path: '/selectionassistant'
      fullPath: '/selectionassistant'
      preLoaderRoute: typeof SelectionassistantRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/stc': {
      id: '/stc'
      path: '/stc'
      fullPath: '/stc'
      preLoaderRoute: typeof StcRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/wishlist': {
      id: '/wishlist'
      path: '/wishlist'
      fullPath: '/wishlist'
      preLoaderRoute: typeof WishlistRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/c/$categoryCode': {
      id: '/c/$categoryCode'
      path: '/c/$categoryCode'
      fullPath: '/c/$categoryCode'
      preLoaderRoute: typeof CCategoryCodeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/cart/': {
      id: '/cart/'
      path: '/cart'
      fullPath: '/cart/'
      preLoaderRoute: typeof CartIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/cart/request': {
      id: '/cart/request'
      path: '/cart/request'
      fullPath: '/cart/request'
      preLoaderRoute: typeof CartRequestRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/cart/store-finder': {
      id: '/cart/store-finder'
      path: '/cart/store-finder'
      fullPath: '/cart/store-finder'
      preLoaderRoute: typeof CartStoreFinderRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/datasheet/$productDesignation': {
      id: '/datasheet/$productDesignation'
      path: '/datasheet/$productDesignation'
      fullPath: '/datasheet/$productDesignation'
      preLoaderRoute: typeof DatasheetProductDesignationRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/embeddedProductConfigurator/$productCode': {
      id: '/embeddedProductConfigurator/$productCode'
      path: '/embeddedProductConfigurator/$productCode'
      fullPath: '/embeddedProductConfigurator/$productCode'
      preLoaderRoute: typeof EmbeddedProductConfiguratorProductCodeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/lms/activate': {
      id: '/lms/activate'
      path: '/lms/activate'
      fullPath: '/lms/activate'
      preLoaderRoute: typeof LmsActivateRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/my-account/': {
      id: '/my-account/'
      path: '/my-account'
      fullPath: '/my-account/'
      preLoaderRoute: typeof MyAccountIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/my-account/accountSettings': {
      id: '/my-account/accountSettings'
      path: '/my-account/accountSettings'
      fullPath: '/my-account/accountSettings'
      preLoaderRoute: typeof MyAccountAccountSettingsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/my-account/contractOverview': {
      id: '/my-account/contractOverview'
      path: '/my-account/contractOverview'
      fullPath: '/my-account/contractOverview'
      preLoaderRoute: typeof MyAccountContractOverviewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/my-account/new-contract': {
      id: '/my-account/new-contract'
      path: '/my-account/new-contract'
      fullPath: '/my-account/new-contract'
      preLoaderRoute: typeof MyAccountNewContractRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/my-account/orderAndQuoteSettings': {
      id: '/my-account/orderAndQuoteSettings'
      path: '/my-account/orderAndQuoteSettings'
      fullPath: '/my-account/orderAndQuoteSettings'
      preLoaderRoute: typeof MyAccountOrderAndQuoteSettingsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/notifications/': {
      id: '/notifications/'
      path: '/notifications'
      fullPath: '/notifications/'
      preLoaderRoute: typeof NotificationsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/notifications/settings': {
      id: '/notifications/settings'
      path: '/notifications/settings'
      fullPath: '/notifications/settings'
      preLoaderRoute: typeof NotificationsSettingsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/orders/': {
      id: '/orders/'
      path: '/orders'
      fullPath: '/orders/'
      preLoaderRoute: typeof OrdersIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/orders/$id': {
      id: '/orders/$id'
      path: '/orders/$id'
      fullPath: '/orders/$id'
      preLoaderRoute: typeof OrdersIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/p/$productCode': {
      id: '/p/$productCode'
      path: '/p/$productCode'
      fullPath: '/p/$productCode'
      preLoaderRoute: typeof PProductCodeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/plp/$categoryCode': {
      id: '/plp/$categoryCode'
      path: '/plp/$categoryCode'
      fullPath: '/plp/$categoryCode'
      preLoaderRoute: typeof PlpCategoryCodeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/quote/': {
      id: '/quote/'
      path: '/quote'
      fullPath: '/quote/'
      preLoaderRoute: typeof QuoteIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/quotes/': {
      id: '/quotes/'
      path: '/quotes'
      fullPath: '/quotes/'
      preLoaderRoute: typeof QuotesIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/quotes/$id': {
      id: '/quotes/$id'
      path: '/quotes/$id'
      fullPath: '/quotes/$id'
      preLoaderRoute: typeof QuotesIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/requestLinearConfigurationQuote/confirmation': {
      id: '/requestLinearConfigurationQuote/confirmation'
      path: '/requestLinearConfigurationQuote/confirmation'
      fullPath: '/requestLinearConfigurationQuote/confirmation'
      preLoaderRoute: typeof RequestLinearConfigurationQuoteConfirmationRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/savedConfigurator/$code': {
      id: '/savedConfigurator/$code'
      path: '/savedConfigurator/$code'
      fullPath: '/savedConfigurator/$code'
      preLoaderRoute: typeof SavedConfiguratorCodeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/search/': {
      id: '/search/'
      path: '/search'
      fullPath: '/search/'
      preLoaderRoute: typeof SearchIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/search/searchpage': {
      id: '/search/searchpage'
      path: '/search/searchpage'
      fullPath: '/search/searchpage'
      preLoaderRoute: typeof SearchSearchpageRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sendLinearConfigurationsViaEmail/confirmation': {
      id: '/sendLinearConfigurationsViaEmail/confirmation'
      path: '/sendLinearConfigurationsViaEmail/confirmation'
      fullPath: '/sendLinearConfigurationsViaEmail/confirmation'
      preLoaderRoute: typeof SendLinearConfigurationsViaEmailConfirmationRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sendWishlistViaEmail/confirmation': {
      id: '/sendWishlistViaEmail/confirmation'
      path: '/sendWishlistViaEmail/confirmation'
      fullPath: '/sendWishlistViaEmail/confirmation'
      preLoaderRoute: typeof SendWishlistViaEmailConfirmationRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/static/welcome': {
      id: '/static/welcome'
      path: '/static/welcome'
      fullPath: '/static/welcome'
      preLoaderRoute: typeof StaticWelcomeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/store-finder/': {
      id: '/store-finder/'
      path: '/store-finder'
      fullPath: '/store-finder/'
      preLoaderRoute: typeof StoreFinderIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/store-finder/confirmation': {
      id: '/store-finder/confirmation'
      path: '/store-finder/confirmation'
      fullPath: '/store-finder/confirmation'
      preLoaderRoute: typeof StoreFinderConfirmationRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/$productCode/configuratorPage/LinearConfigurator': {
      id: '/$productCode/configuratorPage/LinearConfigurator'
      path: '/$productCode/configuratorPage/LinearConfigurator'
      fullPath: '/$productCode/configuratorPage/LinearConfigurator'
      preLoaderRoute: typeof ProductCodeConfiguratorPageLinearConfiguratorRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/checkout/orderConfirmation/$referenceCode': {
      id: '/checkout/orderConfirmation/$referenceCode'
      path: '/checkout/orderConfirmation/$referenceCode'
      fullPath: '/checkout/orderConfirmation/$referenceCode'
      preLoaderRoute: typeof CheckoutOrderConfirmationReferenceCodeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login/pw/change': {
      id: '/login/pw/change'
      path: '/login/pw/change'
      fullPath: '/login/pw/change'
      preLoaderRoute: typeof LoginPwChangeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/quote/confirm/': {
      id: '/quote/confirm/'
      path: '/quote/confirm'
      fullPath: '/quote/confirm/'
      preLoaderRoute: typeof QuoteConfirmIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/quote/confirm/$orderCode': {
      id: '/quote/confirm/$orderCode'
      path: '/quote/confirm/$orderCode'
      fullPath: '/quote/confirm/$orderCode'
      preLoaderRoute: typeof QuoteConfirmOrderCodeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/registered/user/': {
      id: '/registered/user/'
      path: '/registered/user'
      fullPath: '/registered/user/'
      preLoaderRoute: typeof RegisteredUserIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/registered/user/confirmation': {
      id: '/registered/user/confirmation'
      path: '/registered/user/confirmation'
      fullPath: '/registered/user/confirmation'
      preLoaderRoute: typeof RegisteredUserConfirmationRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/carriages/$productCode/carriagesConfiguratorPage/LinearConfigurator': {
      id: '/carriages/$productCode/carriagesConfiguratorPage/LinearConfigurator'
      path: '/carriages/$productCode/carriagesConfiguratorPage/LinearConfigurator'
      fullPath: '/carriages/$productCode/carriagesConfiguratorPage/LinearConfigurator'
      preLoaderRoute: typeof CarriagesProductCodeCarriagesConfiguratorPageLinearConfiguratorRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/checkout/multi/summary/view': {
      id: '/checkout/multi/summary/view'
      path: '/checkout/multi/summary/view'
      fullPath: '/checkout/multi/summary/view'
      preLoaderRoute: typeof CheckoutMultiSummaryViewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/my-company/organization-management/manage-users/': {
      id: '/my-company/organization-management/manage-users/'
      path: '/my-company/organization-management/manage-users'
      fullPath: '/my-company/organization-management/manage-users/'
      preLoaderRoute: typeof MyCompanyOrganizationManagementManageUsersIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/my-company/organization-management/manage-users/create': {
      id: '/my-company/organization-management/manage-users/create'
      path: '/my-company/organization-management/manage-users/create'
      fullPath: '/my-company/organization-management/manage-users/create'
      preLoaderRoute: typeof MyCompanyOrganizationManagementManageUsersCreateRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/my-company/organization-management/manage-users/edit': {
      id: '/my-company/organization-management/manage-users/edit'
      path: '/my-company/organization-management/manage-users/edit'
      fullPath: '/my-company/organization-management/manage-users/edit'
      preLoaderRoute: typeof MyCompanyOrganizationManagementManageUsersEditRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/rails/$productCode/railsConfiguratorPage/LinearConfigurator': {
      id: '/rails/$productCode/railsConfiguratorPage/LinearConfigurator'
      path: '/rails/$productCode/railsConfiguratorPage/LinearConfigurator'
      fullPath: '/rails/$productCode/railsConfiguratorPage/LinearConfigurator'
      preLoaderRoute: typeof RailsProductCodeRailsConfiguratorPageLinearConfiguratorRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/shaft/$productCode/shaftConfiguratorPage/LinearConfigurator': {
      id: '/shaft/$productCode/shaftConfiguratorPage/LinearConfigurator'
      path: '/shaft/$productCode/shaftConfiguratorPage/LinearConfigurator'
      fullPath: '/shaft/$productCode/shaftConfiguratorPage/LinearConfigurator'
      preLoaderRoute: typeof ShaftProductCodeShaftConfiguratorPageLinearConfiguratorRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/my-account/contractDetails/$contractCode/$materialNumber/$packCode/$contractPosition': {
      id: '/my-account/contractDetails/$contractCode/$materialNumber/$packCode/$contractPosition'
      path: '/my-account/contractDetails/$contractCode/$materialNumber/$packCode/$contractPosition'
      fullPath: '/my-account/contractDetails/$contractCode/$materialNumber/$packCode/$contractPosition'
      preLoaderRoute: typeof MyAccountContractDetailsContractCodeMaterialNumberPackCodeContractPositionRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  SplatRoute: SplatRoute,
  BearingFrequencyCalculatorRoute: BearingFrequencyCalculatorRoute,
  BecomeSchaefflerCustomerRoute: BecomeSchaefflerCustomerRoute,
  CampaignRoute: CampaignRoute,
  ContactUsRoute: ContactUsRoute,
  CopySharedWishlistRoute: CopySharedWishlistRoute,
  CopyWishlistRoute: CopyWishlistRoute,
  DigitalServiceRoute: DigitalServiceRoute,
  FreecapacitycockpitRoute: FreecapacitycockpitRoute,
  HousingselectionassistantRoute: HousingselectionassistantRoute,
  LubricationSelectionAssistantRoute: LubricationSelectionAssistantRoute,
  MediaLibraryRoute: MediaLibraryRoute,
  OpenOrdersRoute: OpenOrdersRoute,
  PreviewContentRoute: PreviewContentRoute,
  SavedConfigsRoute: SavedConfigsRoute,
  ScandmcRoute: ScandmcRoute,
  SdsMediaLibraryRoute: SdsMediaLibraryRoute,
  SelectaccountRoute: SelectaccountRoute,
  SelectionassistantRoute: SelectionassistantRoute,
  StcRoute: StcRoute,
  WishlistRoute: WishlistRoute,
  CCategoryCodeRoute: CCategoryCodeRoute,
  CartRequestRoute: CartRequestRoute,
  CartStoreFinderRoute: CartStoreFinderRoute,
  DatasheetProductDesignationRoute: DatasheetProductDesignationRoute,
  EmbeddedProductConfiguratorProductCodeRoute:
    EmbeddedProductConfiguratorProductCodeRoute,
  LmsActivateRoute: LmsActivateRoute,
  MyAccountAccountSettingsRoute: MyAccountAccountSettingsRoute,
  MyAccountContractOverviewRoute: MyAccountContractOverviewRoute,
  MyAccountNewContractRoute: MyAccountNewContractRoute,
  MyAccountOrderAndQuoteSettingsRoute: MyAccountOrderAndQuoteSettingsRoute,
  NotificationsSettingsRoute: NotificationsSettingsRoute,
  OrdersIdRoute: OrdersIdRoute,
  PProductCodeRoute: PProductCodeRoute,
  PlpCategoryCodeRoute: PlpCategoryCodeRoute,
  QuotesIdRoute: QuotesIdRoute,
  RequestLinearConfigurationQuoteConfirmationRoute:
    RequestLinearConfigurationQuoteConfirmationRoute,
  SavedConfiguratorCodeRoute: SavedConfiguratorCodeRoute,
  SearchSearchpageRoute: SearchSearchpageRoute,
  SendLinearConfigurationsViaEmailConfirmationRoute:
    SendLinearConfigurationsViaEmailConfirmationRoute,
  SendWishlistViaEmailConfirmationRoute: SendWishlistViaEmailConfirmationRoute,
  StaticWelcomeRoute: StaticWelcomeRoute,
  StoreFinderConfirmationRoute: StoreFinderConfirmationRoute,
  CartIndexRoute: CartIndexRoute,
  MyAccountIndexRoute: MyAccountIndexRoute,
  NotificationsIndexRoute: NotificationsIndexRoute,
  OrdersIndexRoute: OrdersIndexRoute,
  QuoteIndexRoute: QuoteIndexRoute,
  QuotesIndexRoute: QuotesIndexRoute,
  SearchIndexRoute: SearchIndexRoute,
  StoreFinderIndexRoute: StoreFinderIndexRoute,
  ProductCodeConfiguratorPageLinearConfiguratorRoute:
    ProductCodeConfiguratorPageLinearConfiguratorRoute,
  CheckoutOrderConfirmationReferenceCodeRoute:
    CheckoutOrderConfirmationReferenceCodeRoute,
  LoginPwChangeRoute: LoginPwChangeRoute,
  QuoteConfirmOrderCodeRoute: QuoteConfirmOrderCodeRoute,
  RegisteredUserConfirmationRoute: RegisteredUserConfirmationRoute,
  QuoteConfirmIndexRoute: QuoteConfirmIndexRoute,
  RegisteredUserIndexRoute: RegisteredUserIndexRoute,
  CarriagesProductCodeCarriagesConfiguratorPageLinearConfiguratorRoute:
    CarriagesProductCodeCarriagesConfiguratorPageLinearConfiguratorRoute,
  CheckoutMultiSummaryViewRoute: CheckoutMultiSummaryViewRoute,
  MyCompanyOrganizationManagementManageUsersCreateRoute:
    MyCompanyOrganizationManagementManageUsersCreateRoute,
  MyCompanyOrganizationManagementManageUsersEditRoute:
    MyCompanyOrganizationManagementManageUsersEditRoute,
  RailsProductCodeRailsConfiguratorPageLinearConfiguratorRoute:
    RailsProductCodeRailsConfiguratorPageLinearConfiguratorRoute,
  ShaftProductCodeShaftConfiguratorPageLinearConfiguratorRoute:
    ShaftProductCodeShaftConfiguratorPageLinearConfiguratorRoute,
  MyCompanyOrganizationManagementManageUsersIndexRoute:
    MyCompanyOrganizationManagementManageUsersIndexRoute,
  MyAccountContractDetailsContractCodeMaterialNumberPackCodeContractPositionRoute:
    MyAccountContractDetailsContractCodeMaterialNumberPackCodeContractPositionRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
